import $ from 'jquery';

export default function filiali() {

  function init() {
    //Pagina "Filiali": le filiali divise in pagine (città)
    $('#filiali-wcm').on('change', function() {
      let paginaFiliale = $(this).val();
      window.location = paginaFiliale;
    });

    //Pagina "Filiali": tutte le filiali caricate in pagina
    $('#filiali').on('change', function() {
      let filiale = $(this).val();
      $('#filiali-list div[data-filter]').addClass('d-none');
      
      if(filiale != 'all') {
        $('#filiali-list div[data-filter="'+filiale+'"').removeClass('d-none');
      } else {
        $('#filiali-list div[data-filter]').removeClass('d-none');
      }
    });
  }

  function formAppuntamento() {
    $('.bcp-form #setNomeFiliale').on('change', function() {
      let nomeFiliale = $(this).children(':selected').text();
      $('#nomeFiliale').val(nomeFiliale);

      // console.log("Filiale scelta:", nomeFiliale);
    });
  }

  function textareaWCM() {
    if($('#richiesta').val().length < 2) {
      $('#richiesta').val($.trim($(this).val()));
    }
  }
  
  $( document ).ready(function() {
    if($('#filiali, #filiali-wcm').length > 0) {
      init();
    }
    if($('.bcp-form #nomeFiliale').length > 0) {
      formAppuntamento();
    }
    
    //textarea wcm trim spazi iniziali
    if ($('.bcp-form #richiesta').length > 0) {
      textareaWCM();
    }
  });  
}




























